import { cx, css } from '@emotion/css';
import React from 'react';
import { useStyles2, Icon } from '@grafana/ui';
import { SceneObjectBase } from '../../../core/SceneObjectBase.js';
import { SceneGridLayout } from './SceneGridLayout.js';
import { GRID_COLUMN_COUNT } from './constants.js';
import { sceneGraph } from '../../../core/sceneGraph/index.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class SceneGridRow extends SceneObjectBase {
  constructor(state) {
    super(__spreadProps(__spreadValues({
      children: state.children || [],
      isCollapsible: state.isCollapsible || true,
      title: state.title || ""
    }, state), {
      x: 0,
      height: 1,
      width: GRID_COLUMN_COUNT
    }));
    this.onCollapseToggle = () => {
      if (!this.state.isCollapsible) {
        return;
      }
      this.getGridLayout().toggleRow(this);
    };
  }
  getGridLayout() {
    const layout = this.parent;
    if (!layout || !(layout instanceof SceneGridLayout)) {
      throw new Error("SceneGridRow must be a child of SceneGridLayout");
    }
    return layout;
  }
  getUrlState() {
    return { rowc: this.state.isCollapsed ? "1" : "0" };
  }
  updateFromUrl(values) {
    if (values.rowc == null) {
      return;
    }
    if (values.rowc !== this.getUrlState().rowc) {
      this.onCollapseToggle();
    }
  }
}
SceneGridRow.Component = SceneGridRowRenderer;
function SceneGridRowRenderer({ model }) {
  const styles = useStyles2(getSceneGridRowStyles);
  const { isCollapsible, isCollapsed, title, isDraggable, actions } = model.useState();
  const layoutDragClass = model.getGridLayout().getDragClass();
  return /* @__PURE__ */ React.createElement("div", {
    className: cx(styles.row, isCollapsed && styles.rowCollapsed)
  }, /* @__PURE__ */ React.createElement("button", {
    onClick: model.onCollapseToggle,
    className: styles.rowTitleButton,
    "aria-label": isCollapsed ? "Expand row" : "Collapse row"
  }, isCollapsible && /* @__PURE__ */ React.createElement(Icon, {
    name: isCollapsed ? "angle-right" : "angle-down"
  }), /* @__PURE__ */ React.createElement("span", {
    className: styles.rowTitle,
    role: "heading"
  }, sceneGraph.interpolate(model, title, void 0, "text"))), actions && /* @__PURE__ */ React.createElement(actions.Component, {
    model: actions
  }), isDraggable && isCollapsed && /* @__PURE__ */ React.createElement("div", {
    className: cx(styles.dragHandle, layoutDragClass)
  }, /* @__PURE__ */ React.createElement(Icon, {
    name: "draggabledots"
  })));
}
const getSceneGridRowStyles = (theme) => {
  return {
    row: css({
      width: "100%",
      height: "30px",
      display: "flex",
      justifyContent: "space-between",
      gap: theme.spacing(1)
    }),
    rowTitleButton: css({
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      background: "transparent",
      border: "none",
      gap: theme.spacing(1)
    }),
    rowCollapsed: css({
      borderBottom: `1px solid ${theme.colors.border.weak}`
    }),
    rowTitle: css({
      fontSize: theme.typography.h5.fontSize,
      fontWeight: theme.typography.fontWeightMedium
    }),
    collapsedInfo: css({
      fontSize: theme.typography.bodySmall.fontSize,
      color: theme.colors.text.secondary,
      display: "flex",
      alignItems: "center",
      flexGrow: 1
    }),
    dragHandle: css({
      display: "flex",
      padding: theme.spacing(0, 1),
      alignItems: "center",
      justifyContent: "flex-end",
      cursor: "move",
      color: theme.colors.text.secondary,
      "&:hover": {
        color: theme.colors.text.primary
      }
    })
  };
};

export { SceneGridRow, SceneGridRowRenderer, getSceneGridRowStyles };
//# sourceMappingURL=SceneGridRow.js.map
